<template>
  <div class="pa-4">
    <v-row class="print-order-container" dense>
      <v-col cols="12" class="d-flex align-center d-print-none">
        <v-btn
          :to="{ name: ManageOrdersRoute }"
          exact
          class="d-flex"
          outlined
          small
          color="deep-orange"
          ><v-icon small left>mdi-arrow-left</v-icon>Back to Orders</v-btn
        >
      </v-col>
      <v-col cols="12">
        <WithEntity
          v-slot="{ entity, loading }"
          :Model="Model"
          :id="id"
          view-type="detail"
        >
          <div v-if="loading">Loading...</div>
          <v-row v-else>
            <v-col cols="12">
              <AdminPrintOrder
                :entity="entity"
                @form:valid="isFormValid = $event"
                @update="$emit('update', $event)"
                @hook:created="original = entity"
              />
            </v-col>
          </v-row>
        </WithEntity>
      </v-col>
    </v-row>
    <v-snackbar
      bottom
      timeout="-1"
      :value="true"
      color="blue darken-2"
      class="d-print-none proxima-bold--font"
    >
      This will print on a tall half sheet of 8.5" x 11" paper.<br />For best
      results, please remove all margins in your print settings.
    </v-snackbar>
  </div>
</template>

<script>
import _get from 'lodash/get'

import { Model } from '@vuex-orm/core'
import AllModels from '@/models'
import RouteNames from '@/constants/RouteNames'

import WithEntity from '@/components/DataProviders/WithEntity'
import AdminPrintOrder from '@/components/AdminPrintOrder'

export default {
  name: 'PrintOrderView',
  components: {
    WithEntity,
    AdminPrintOrder,
  },
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
    id: {
      type: [String, Number],
      require: true,
      default: null,
    },
  },
  meta() {
    return {
      title: this.metaTitle,
    }
  },
  data() {
    return {
      AllModels,
      ManageOrdersRoute: RouteNames.Merchant.Manage.ORDERS,
    }
  },

  methods: {}, // methods

  computed: {
    modelName() {
      return this.Model.nameSingular
    },
    metaTitle() {
      return this.ticketNumber
        ? `${this.modelName} #${this.ticketNumber} - Minimart`
        : null
    },
    theOrder() {
      return AllModels.OrderModel.find(this.id)
    },
    ticketNumber() {
      return _get(this, 'theOrder.ticket_number')
    },
  },
}
</script>

<style lang="scss">
.print-order-container {
  max-width: 450px;
  @media print {
    max-width: 4in;
  }
}
</style>
